"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIAL_TERMS_RENEWAL_COPY = void 0;
exports.trialTermsLine = trialTermsLine;
exports.TRIAL_TERMS_RENEWAL_COPY = "Renews automatically; cancel anytime.";
function trialTermsLine(o) {
    const charge = `${o.price} a ${o.interval}.`;
    if (!(o.trialDays > 0))
        return `${charge} ${exports.TRIAL_TERMS_RENEWAL_COPY}`;
    const days = o.trialDays === 1 ? "1 day" : `${o.trialDays} days`;
    return `${days} free, then ${charge} ${exports.TRIAL_TERMS_RENEWAL_COPY}`;
}
//# sourceMappingURL=trialTermsCopy.js.map